import React, { useEffect } from "react";
import zongsmallIcon from "../../../assets/images/zong/loader-icon.svg";
import { useAuth } from "../../../Context/AuthProvider";
import { determineAllowedRoute } from "../../../Utils/PermissionFunctions";
// import Footer from "../../common/Footer/Footer";
// import Header from "../../common/Header/Header";

const SplashScreen = () => {
  const { auth } = useAuth();

  // function determineAllowedRoute(userData) {
  //   const allowedPages = ["dashboard", "call-records", "vpbx-manager"];
  //   let allowedRoute = "notFound";

  //   // Iterate through each object in the userData array
  //   for (const page of userData) {
  //     // Check if the page_name is one of the allowedPages
  //     if (allowedPages.includes(page.page_name)) {
  //       // Check if either read_and_write or read_only is 1
  //       if (page.read_and_write === 1 || page.read_only === 1) {
  //         // Store the route of the first page found
  //         allowedRoute = page.page_name;
  //         break; // Exit loop once a valid page is found
  //       }
  //     }
  //   }

  //   return allowedRoute;
  // }

  useEffect(() => {
    let route;
    if (auth.role === "3") {
  
      route = determineAllowedRoute();
    }
    setTimeout(() => {
      sessionStorage.setItem("displayed", true);
      if (auth.role === "3") {
        window.location.href = `/${route}`;
      } else {
        window.location.href = `/dashboard`;
      }
    }, 5000);
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("displayed") !== null) {
      window.location.href = "/dashboard";
    }
  }, []);
  return (
    <>
      <div className="splashBody">
        <div className="splashScreen">
          <div className="loadingContainer">
            <div className="loadingBox">
              <img src={zongsmallIcon} className="splashLogo" alt="" />
              <div className="loadingBarContainer">
                <div className="loadingbar"></div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="splashBehind">
          <Header />
          <div className="splashBehindMain">
            <h1 className="fade-in-text">WELCOME</h1>
            <h1 className="fade-in-text1 upperCase">
              {localStorage.getItem("userName")}
            </h1>
          </div>
        </div>
        <Footer /> */}
      </div>
    </>
  );
};
export default SplashScreen;
